import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Observer from "gsap/Observer";
gsap.registerPlugin(ScrollTrigger, Observer);

/**
 * `.bounce-in` 要素のbottomが画面のbottomに達したら `is-active` クラスを付与する
 *
 * @param {ParentNode} root - 探索範囲。後から生成した要素だけを対象にしたいときに渡す
 * @returns {void}
 * @example
 * initBounceIn();
 */
export const initBounceIn = (root: ParentNode = document): void => {
  const elements = root.querySelectorAll<HTMLElement>(".bounce-in, .bounce-in-slow");

  elements.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "bottom bottom",
      onEnter: () => {
        el.classList.add("is-active");
      },
    });
  });
};

/**
 * `.fade-in` 要素のbottomが画面のbottomに達したら `is-active` クラスを付与する
 *
 * @param {ParentNode} root - 探索範囲。後から生成した要素だけを対象にしたいときに渡す
 * @returns {void}
 * @example
 * initFadeIn();
 */
export const initFadeIn = (root: ParentNode = document): void => {
  const elements = root.querySelectorAll<HTMLElement>(".fade-in");

  elements.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      once: true,
      start: "top 75%",
      onEnter: () => {
        el.classList.add("is-active");
      },
    });
  });
};

initBounceIn();
initFadeIn();
